import environment from "../../../settings/environment";
import { AxiosResponse } from "axios";
import { Action } from "redux-saga";
import { call, CallEffect, PutEffect } from "redux-saga/effects";
import { clearString } from "../../../utils/functions";
import api from "../../../settings/api";

export interface Fetch {
  document: string;
  callback: (success: boolean, errorMessage?: string) => void;
}

export interface SendPinAction {
  type: string;
  payload: Fetch;
}

export default function* sendPin({
  payload,
}: SendPinAction): Generator<
  CallEffect<unknown> | PutEffect<Action>,
  void,
  AxiosResponse
> {
  try {
    const data = {
      companyIdentification: environment.api.companyIdentification,
      userIdentification: environment.api.userIdentification,
      document: clearString(payload.document),
      channel: environment.api.channel,
    };
    const response = yield call(api.post, `/v1/customers/pins`, data);

    if (response?.data?.status?.codigoRetorno === 0) {
      yield call(payload.callback, true);
    } else {
      yield call(payload.callback, false, "error");
    }
  } catch (error) {
    yield call(payload.callback, false, "timeout");
  }
}
